import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {FormControl} from '@angular/forms';
// import { MatStepper } from '@angular/material/stepper';


@Component({
  selector: 'app-list-page-component',
  templateUrl: './list-page-component.component.html',
  styleUrls: ['./list-page-component.component.css']
})
export class ListPageComponentComponent implements OnInit {
  @ViewChild('mySidenav') mySidenav!: ElementRef;
  sidenav:Boolean = false;
  mode!:any;
  shouldRun:any
  constructor() { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers'
      };
  }
  
  tableColumns: Array<any> = [
    { name: "Equipment Category", dataKey: "title1", displayColumn: true, sortDirection: '',static:true },
    { name: "From Start date", dataKey: "title2", displayColumn: true, sortDirection: '',static:true },
    { name: "Added", dataKey: "title3", displayColumn: true, sortDirection: '',static:false },
    { name: "Removed", dataKey: "title4", displayColumn: true, sortDirection: '',static:false },
    { name: "As on End Date", dataKey: "title5", displayColumn: true, sortDirection: '',static:false },
    
]
tableDatas: Array<any> = [
    { title1: "Radiology", title2: '0', title3: "820", title4: "4", title5: "2020/06/12", title6: "q1", title7: "a1", title8: "name 1", title9: "3", title10: "person13person5" },
    { title1: "Radiographic/Fluoroscopic Systems, General-Purpose", title2: "0", title3: "400", title4: "120", title5: "2020/06/12", title6: "q1", title7: "a1", title8: "name 2", title9: "3", title10: "person15person5" },
    { title1: "Analyzers, Automated (High)", title2: "5", title3: "120", title4: "2", title5: "2020/06/12", title6: "q1", title7: "a1", title8: "name 3", title9: "3", title10: "person23person5" },
    { title1: "Analyzers, Automated (Medium)", title2: "2", title3: "60", title4: "15", title5: "2020/06/12", title6: "q1", title7: "a1", title8: "name 4", title9: "3", title10: "person13person5" },
    { title1: "Hoods, Isolation, Laminar Air Flow", title2: "2", title3: "540", title4: "20", title5: "2020/06/12", title6: "q1", title7: "a1", title8: "name 5", title9: "3", title10: "person15person5" },
    { title1: "Chairs, Examination/ Treatment", title2: "2020/02/05", title3: "400", title4: "250", title5: "2020/06/12", title6: "q1", title7: "a1", title8: "name 6", title9: "3", title10: "person23person5" },
    { title1: "Dental Workstation", title2: "2020/02/05", title3: "890", title4: "90", title5: "2020/06/12", title6: "q1", title7: "a1", title8: "name 7", title9: "3", title10: "person13person5" },
    { title1: "Fume Extractor", title2: "2020/02/05", title3: "15", title4: "5", title5: "2020/06/12", title6: "q1", title7: "a1", title8: "name 8", title9: "3", title10: "person15person5" },
    // { title1: "6", title2: "name 3", title3: "qwer7", title4: "person12person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 9", title9: "3", title10: "person23person5" },
    // { title1: "6", title2: "name 3", title3: "qwer7", title4: "person12person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 10", title9: "3", title10: "person13person5" },
    // { title1: "6", title2: "name 3", title3: "qwer7", title4: "person12person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 11", title9: "3", title10: "person13person5" },
    // { title1: "6", title2: "name 3", title3: "qwer7", title4: "person12person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 12", title9: "3", title10: "person13person5" },
    // { title1: "6", title2: "name 3", title3: "qwer6", title4: "person12person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 13", title9: "3", title10: "person15person5" },
    // { title1: "6", title2: "name 3", title3: "qwer5", title4: "person12person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 14", title9: "3", title10: "person15person5" },
    // { title1: "6", title2: "name 3", title3: "qwer9", title4: "person12person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 15", title9: "3", title10: "person15person5" },
    // { title1: "6", title2: "name 3", title3: "qwer8", title4: "person12person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 16", title9: "3", title10: "person23person5" },
    // { title1: "6", title2: "name 3", title3: "qwer2", title4: "person12person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 17", title9: "3", title10: "person23person5" },
    // { title1: "4", title2: "name 4", title3: "qwer3", title4: "person23person5person5person5", title5: "p1", title6: "q1", title7: "a1", title8: "name 18", title9: "3", title10: "person23person5" }
]


changeData() {
    this.tableColumns = [
        { name: "Equipment Category", dataKey: "title1", displayColumn: true, sortDirection: '' },
        { name: "As on Start Date", dataKey: "title2", displayColumn: true, sortDirection: '' },
        { name: "Added", dataKey: "title3", displayColumn: true, sortDirection: '' },
    ]
    this.tableDatas = [
        { title1: "Radiology", title2: "name 1", title3: "3" },
        { title1: "1", title2: "name 6", title3: "4" },
        { title1: "3", title2: "name 2", title3: "5" },
        { title1: "5", title2: "name 5", title3: "6" },
        { title1: "6", title2: "name 3", title3: "7" },
        { title1: "4", title2: "name 4", title3: "8" }
    ]
}
dtOptions: DataTables.Settings = {

};

assetTypes: any[] = [
  {
    id: 1,
    name: 'Radiology',
    date: '2020/02/05',
    added : '820',
    removed : '4',
    endDate : '2020/06/12'
  },
  {
    id: 2,
    name: 'Radiographic/Fluoroscopic Systems, General-Purpose',
    date: '2020/02/05',
    added : '400',
    removed : '120',
    endDate : '2020/06/12'
  },
  {
    id: 3,
    name: 'Analyzers, Automated (High)',
    date: '2020/02/05',
    added : '120',
    removed : '2',
    endDate : '2020/06/12'
  },
  {
    id: 4,
    name: 'Analyzers, Automated (Medium)',
    date: '2020/02/05',
    added : '60',
    removed : '15',
    endDate : '2020/06/12'
  },
  {
    id: 5,
    name: 'Hoods, Isolation, Laminar Air Flow',
    date: '2020/02/05',
    added : '540',
    removed : '20',
    endDate : '2020/06/12'
  },
  {
    id: 6,
    name: 'Chairs, Examination/ Treatment',
    date: '2020/02/05',
    added : '400',
    removed : '250',
    endDate : '2020/06/12'
  },
  // {
  //   id: 7,
  //   name: 'Chairs, Examination/ Treatment, Dentistry, Specialist',
  //   date: '2020/05/11',
  //   added : '0',
  //   removed : '',
  //   endDate : ''
  // },
  {
    id: 8,
    name: 'Dental Workstation',
    date: '2020/02/05',
    added : '890',
    removed : '90',
    endDate : '2020/06/12'
  },
  {
    id: 9,
    name: 'Fume Extractor',
    date: '2020/02/05',
    added : '15',
    removed : '5',
    endDate : '2020/06/12'
  },
];

dataTable2 =[
  {beNumber : 'JHNSCI116',beCategory : 'Scales, Infant',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR174',clinic_type:'KD',age:'',manufacture:'',model:'Seca 3541317619',serial_no:'8.35E+12',batch:'BATCH 7',variation_ord:''},
  {beNumber : 'JHNSCI117',beCategory : 'Scales, Infant',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR178',clinic_type:'KD',age:'',manufacture:'',model:'Seca 3541317619',serial_no:'8.35E+12',batch:'BATCH 7',variation_ord:''},
  {beNumber : 'JHNSCI118',beCategory : 'Scales, Infant',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR180',clinic_type:'KD',age:'',manufacture:'',model:'Seca 3541317619',serial_no:'8.35E+12',batch:'BATCH 7',variation_ord:''},
  {beNumber : 'JHNSCN001',beCategory : 'Scanning Systems, Ultrasonic, General Purpose (Medium)',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR013',clinic_type:'KK4',age:'',manufacture:'',model:'SonoAce R3',serial_no:'S10MM3HJ300037L',batch:'BATCH 3',variation_ord:''},
  {beNumber : 'JHNSCN002',beCategory : 'Scanning Systems, Ultrasonic, General Purpose (Medium)',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR020',clinic_type:'KK4',age:'',manufacture:'',model:'SonoAce R3',serial_no:'S10MM3HJ300035W',batch:'BATCH 3 ',variation_ord:''},
  {beNumber : 'JHNSPA001',beCategory : 'Sphygmomanometers, Electronic, Automatic',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR004',clinic_type:'KK4',age:'',manufacture:'',model:'VS 900 NIBP',serial_no:'FV-72015235',batch:'BATCH 3',variation_ord:''},
  {beNumber : 'JHNSPA002',beCategory : 'Sphygmomanometers, Electronic, Automatic',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR004',clinic_type:'KK4',age:'',manufacture:'',model:'VS 900 NIBP',serial_no:'FV-72015235',batch:'BATCH 3',variation_ord:''},
  {beNumber : 'JHNSPD001',beCategory : 'Spirometers, Diagnostic',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR028',clinic_type:'KK1',age:'',manufacture:'',model:'SPIRO-S',serial_no:'M946800128877',batch:'BATCH 1',variation_ord:''},
  {beNumber : 'JHNSPD002',beCategory : 'Spirometers, Diagnostic',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR029',clinic_type:'KK2',age:'',manufacture:'',model:'SPIRO-S',serial_no:'M946800128881',batch:'BATCH 1',variation_ord:''},
  {beNumber : 'JHNSPD003',beCategory : 'Spirometers, Diagnostic',beCndSts:'ACT',assetCategory : '',clinic_code:'JHR035',clinic_type:'KK3',age:'',manufacture:'',model:'SPIRO-S',serial_no:'NXGVYSM001925314F7600',batch:'Batch 12-SA7',variation_ord:''},
];

}
